import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformPaymentShareWhitelistItems } from './payment-share-whitelist-items.transformer';
import type { PaymentShareWhitelistItemsCollection } from './payment-share-whitelist-items.types';

export function paymentShareWhitelistItemsReducer(
  state: CollectionStateSlice<PaymentShareWhitelistItemsCollection> = {},
  action: CollectionActions<PaymentShareWhitelistItemsCollection>,
): CollectionStateSlice<PaymentShareWhitelistItemsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'paymentShareWhitelistItems') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<PaymentShareWhitelistItemsCollection>(
          state,
          transformIntoDocuments(
            result.whitelist_items,
            transformPaymentShareWhitelistItems,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
